import React, { useState, useEffect, useRef } from 'react';
import Classes from './AddMemberPopup.module.css';
import { useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';

export default function AddMemberPopup({
    handleClose,
    onInvite,
    decision,
    setdecision,
    inviteeEmail,
    setInviteeEmail,
    inviteLoading
}) {
    const onBoarding = useSelector((state) => state.companyInfo.info);
    const companyId = onBoarding?._id;

    const [dropDown, setDropDown] = useState(false);
    const dropdownRef = useRef(null);

    const handleCardClick = (event) => event.stopPropagation();

    const handleInvite = () => {
        if (onInvite) onInvite();
    };

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropDown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Close menu when role changes
    useEffect(() => {
        setDropDown(false);
    }, [decision]);

    const currentRoleLabel =
        decision === 'Admin' ? 'Admin' :
            decision === 'Employee' ? 'Employee' : 'Select role';

    return (
        <>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className={Classes.popup}
            >
                <motion.div
                    initial={{ y: -7 }}
                    animate={{ y: 0 }}
                    exit={{ y: 7 }}
                    transition={{ duration: 0.25 }}
                    className={Classes.card}
                    onClick={handleCardClick}
                >
                    <div className={Classes.close} onClick={handleClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="25px" fill="white" viewBox="0 0 384 512">
                            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                        </svg>
                    </div>

                    <div className={Classes.bgPopup}>
                        <div></div>
                        <h5 className={Classes.title}>Add Team Member</h5>
                        <div className={Classes.curveCon}></div>
                    </div>

                    <div className={Classes.cardCon}>
                        {/* Email */}
                        <label className={Classes.label}>Email</label>
                        <input
                            type="text"
                            placeholder="johndoe@example.com"
                            value={inviteeEmail}
                            onChange={(e) => setInviteeEmail(e.target.value)}
                            className={Classes.inputField}
                        />

                        {/* Role */}
                        <label className={Classes.label} style={{ marginTop: '10px' }}>Role</label>
                        <div className={Classes.dropDown} ref={dropdownRef}>
                            <div
                                className={`${Classes.dropDownHead} ${Classes.roleHead}`}
                                onClick={() => setDropDown((v) => !v)}
                            >
                                <h5 style={{ textTransform: 'capitalize', margin: 0 }}>{currentRoleLabel}</h5>
                                <img
                                    src="/assets/images/arrow-down.svg"
                                    alt="dropdown arrow"
                                    style={{ transform: dropDown ? 'rotate(180deg)' : 'rotate(0deg)' }}
                                />
                            </div>

                            <AnimatePresence>
                                {dropDown && (
                                    <motion.div
                                        initial={{ opacity: 0, y: -5 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -5 }}
                                        transition={{ duration: 0.15 }}
                                        className={Classes.dropDownBody}
                                        style={{ top: '45px', right: '0' }}
                                    >
                                        <div className={Classes.ddPointerCon} style={{ right: '15px' }}>
                                            <div className={Classes.dropDownPointer}></div>
                                        </div>

                                        <div className={Classes.dropDownBodyInner}>
                                            <div
                                                className={`${Classes.dropDownElem} ${decision === 'Admin' ? Classes.activeDropElem : ''}`}
                                                onClick={() => setdecision('Admin')}
                                                style={{ padding: '5px 10px' }}
                                            >
                                                <h5>Admin</h5>
                                            </div>

                                            <div className={Classes.dropDownLine}></div>

                                            <div
                                                className={`${Classes.dropDownElem} ${decision === 'Employee' ? Classes.activeDropElem : ''}`}
                                                onClick={() => setdecision('Employee')}
                                                style={{ padding: '5px 10px' }}
                                            >
                                                <h5>Employee</h5>
                                            </div>
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>

                            <input type="hidden" value={decision} aria-label="role" readOnly />
                        </div>

                        {/* Actions */}
                        <div className={Classes.flexAlign} style={{ marginTop: '2rem' }}>
                            <button className={Classes.btn1} onClick={handleClose} style={{ border: `1px solid var(--secondary-color)` }}>
                                <h5>Cancel</h5>
                            </button>
                            <button className={Classes.btn2} onClick={handleInvite}>
                                <h5>{inviteLoading ? 'Sending...' : 'Send Invite'}</h5>
                            </button>
                        </div>
                    </div>
                </motion.div>
            </motion.div>
        </>
    );
}
